import { isShallowEqual } from "@ajayvikas/common-utils";
import React from "react";
export const useShallowState = (value, areEqual = isShallowEqual) => {
    const [state, setState] = React.useState(value);
    const stateRef = React.useRef(state);
    const updateState = React.useCallback((value) => {
        if (areEqual(value, stateRef.current))
            return false;
        stateRef.current = value;
        setState(value);
        return true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [state, updateState];
};
const isValueEqual = (left, right) => left === right;
export const useStateStrict = (value, areEqual = isValueEqual) => {
    const [state, setState] = React.useState(value);
    const stateRef = React.useRef(state);
    const updateState = React.useCallback((value) => {
        const newValue = typeof value === "function" ? value(state) : value;
        if (areEqual(newValue, stateRef.current))
            return false;
        stateRef.current = newValue;
        setState(newValue);
        return true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [state, updateState];
};
export const useStateRef = (value, areEqual = isValueEqual) => {
    const [, setStateInternal] = useStateStrict(value, areEqual);
    const stateRef = React.useRef(value);
    const updateState = React.useCallback((value) => {
        stateRef.current = value;
        setStateInternal(value);
    }, [setStateInternal]);
    return [stateRef, updateState];
};
export function useStateWithTimer(initialState, delay) {
    const timer = React.useRef();
    const [state, setStateInternal] = useStateStrict(initialState);
    const setState = React.useCallback((value) => {
        setStateInternal(value);
        if (timer.current)
            clearTimeout(timer.current);
        //TODO: potential bug. Subsequest updates to 'initialState' will be lost
        timer.current = setTimeout(() => setStateInternal(initialState), delay);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [state, setState];
}
export function usePropsUpdateEffect(effect, props) {
    const prev = React.useRef();
    React.useEffect(() => {
        if (!prev.current)
            return () => { prev.current = props; };
        //TODO: potential bug. Subsequest updates to 'effect' will be lost
        effect(prev.current);
        return () => { prev.current = props; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);
}
export function useUpdateEffect(effect, deps = []) {
    const counter = React.useRef(0);
    React.useEffect(() => {
        if (counter.current === 0) {
            counter.current = counter.current + 1;
            return;
        }
        return effect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
export function useForceUpdate() {
    const [, setValue] = React.useState({});
    const forceUpdate = React.useCallback(() => {
        setValue({});
    }, []);
    return forceUpdate;
}
